module.exports = __webpack_public_path__ + "img/logo.e6e9742d.png";